import React from 'react';
const Banner = () => {
  return (
    <div className="relative w-full">
      <img
        src="banner.png"
        alt="Banner"
        className="w-full h-auto block"
      />
    </div>
  );
};

export default Banner;